// extracted by mini-css-extract-plugin
module.exports = {"Background":"BSOD_Background__1wscN","SadFace":"BSOD_SadFace__2XMHP","Text":"BSOD_Text__2nbay","TextContainer":"BSOD_TextContainer__3bL0S","ReloadLink":"BSOD_ReloadLink__1Zj6E"};